export enum GameKind {
  ANY = 'any',
  IMAGE = 'img',
  VIDEO = 'vid',
}

export default interface HeyGame {
  id: string
  challenge: string
  album: string
  kind?: GameKind
}
